import React from "react";
import {Button, CircularProgress, FormLabel, Grid, TextField} from "@material-ui/core";
import {Cancel, Edit, Save} from "@material-ui/icons";
import classNames from 'classnames';


function PasswordManagement(props) {
    const {oldPassword, newPassword, passwordEdit} = props.allState;
    const { infoChange, allProps, changePassword, cancel } = props;
    return(
        <Grid item>
            <FormLabel component="legend">Password Management</FormLabel>
            <TextField
                id="outlined-name"
                label="Old Password"
                className={props.classes.textField}
                value={oldPassword}
                onChange={infoChange}
                name='oldPassword'
                fullWidth
                margin="dense"
                type="password"
                variant="outlined"
                disabled={passwordEdit}
            />

            <TextField
                id="outlined-name"
                label="New password"
                className={props.classes.textField}
                value={newPassword}
                onChange={infoChange}
                name='newPassword'
                fullWidth
                margin="dense"
                type="password"
                variant="outlined"
                disabled={passwordEdit}
            />
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-start"
                style={{'paddingTop':'10px'}}
            >
                {allProps.passwordChg
                    ?
                    <CircularProgress className={props.classes.progress} size={21}/>
                    :
                    <div>
                        {passwordEdit ?
                            <Grid item>
                                <Button variant="contained" color="default" size="small" onClick={props.stateChanger}
                                        className={props.classes.button}>
                                    <Edit className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                    Change
                                </Button>
                            </Grid>
                            :
                            <Grid item>
                                <Grid
                                    container
                                    direction="row"
                                    justify="flex-end"
                                    alignItems="flex-start"
                                    spacing={8}
                                >
                                    <Grid item>
                                        <Button variant="contained" color="secondary" size="small" onClick={changePassword}
                                                className={props.classes.button}>
                                            <Save className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                            Update
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="contained" color="primary" size="small" onClick={cancel}
                                                className={props.classes.button}>
                                            <Cancel className={classNames(props.classes.leftIcon, props.classes.iconSmall)}/>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </div>
                }
            </Grid>
        </Grid>
    )
}

export default PasswordManagement;